<template>
  <el-upload :action="FileUploadURL"  :show-file-list="false"  :on-success="handleSuccess" :before-upload="handlebeforeUpload"  :accept="accept">
    <el-button size="mini" icon="el-icon-plus"  v-loading="loading">{{buttonText}}</el-button>
  </el-upload>
</template>

<script>
export default {
  props: {
    value: String,
    size: {
      type: Boolean,
      default: false
    },
    buttonText:{
      type:String,
      default:'上传'
    },
    accept:{
      type:String,
      default:'image/*,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/*,application/msword,application/vnd.ms-excel'
    }
  },
  data() {
    return {
      FileUploadURL: this.$common.FileUploadURL,
      loading: false,
      name: ''
    };
  },
  methods: {
    handleSuccess(res, file) {
      this.loading = false;
      if(res.code == 1000){
        this.$message.success('上传成功')
        const imageUrl = res.data
        this.name = file.name
        this.$emit('input', imageUrl)
        this.$emit('fileNameEvt', file.name)
        this.$forceUpdate();
      } else {
        return this.$message.error('上传失败')
      }
    },
    handlebeforeUpload(file) {
      console.log(file.type,'===file.type')
      this.loading=true;
      let  isImg = false
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === "application/pdf" || file.type === 'application/msword' || file.type === 'application/vnd.ms-excel'|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type ==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        isImg = true;
      }
      if (!isImg) {
        this.loading = false
        this.$message.error('上传文件只能是JPG、PNG、PDF、WORD、EXCEL格式 !')
      }
      // 校验文件大小
      if (this.size) {
        let isLt5M = file.size / 1024 / 1024 < 50
        if (!isLt5M) {
          this.loading = false
          this.$message.error('上传图片大小不能超过 50MB!')
        }
        return isImg && isLt5M
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.h15 {
  height: 15px;
}
</style>